export const SIZES = {
  sm: 'px-1.5 py-0.5',
  md: 'px-2 py-1',
};

export const COLORS = {
  gray: 'bg-gray-400/10 text-gray-400 ring-gray-400/20',
  red: 'bg-red-400/10 text-red-400 ring-red-400/20',
  yellow: 'bg-yellow-400/10 text-yellow-500 ring-yellow-400/20',
  green: 'bg-green-400/10 text-green-400 ring-green-400/20',
  blue: 'bg-blue-400/10 text-blue-400 ring-blue-400/20',
  indigo: 'bg-indigo-400/10 text-indigo-400 ring-indigo-400/30',
  purple: 'bg-purple-400/10 text-purple-400 ring-purple-400/20',
  pink: 'bg-pink-400/10 text-pink-400 ring-pink-400/20',
};
